import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Test } from 'src/app/models/test.model';

@Component({
  selector: 'ct-last-page-report',
  templateUrl: './last-page-report.component.html',
  styleUrls: ['./last-page-report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LastPageReportComponent implements OnInit {

  @Input() colors: any;
  @Input() test!: Test;

  constructor() { }

  ngOnInit(): void {
  }

}
